// extracted by mini-css-extract-plugin
export default {"pubImgMain":"PubImageHeader_pubImgMain__Rll1o","publogo":"PubImageHeader_publogo__DYsyK","pubImg":"PubImageHeader_pubImg__obZOk","center":"PubImageHeader_center__QwyqI"};